// LAYOUT F — the buttons for the card shown, in one row under the large card (also in the
// full-screen CardZoom). Two buttons side by side, or one full width. A button that can't be
// used right now stays visible but greyed, with a short reason under it.
// Labels are short ("Play", "Take (3)", "Discard (1 left)") so they always fit on one line; the card's
// name is on the large card above; the reason line shows in full (it may wrap to 2 lines).
// buttons: [{ testid, label, title, onClick, enabled, reason, primary, danger }]
export default function CardActions({ buttons = [], testid = "card-actions", large = false }) {
  if (!buttons.length) return null;
  return (
    <div data-testid={testid} className="shrink-0 grid w-full" style={{ gridTemplateColumns: `repeat(${buttons.length}, minmax(0, 1fr))`, columnGap: 6, rowGap: 3 }}>
      {buttons.map((b) => (
        <div key={b.testid} className="min-w-0 flex flex-col" style={{ gap: 3 }}>
          <button
            type="button"
            data-testid={b.testid}
            onClick={b.onClick}
            disabled={!b.enabled}
            title={b.enabled ? b.title || b.label : b.reason || b.title || b.label}
            className={`${b.primary ? "btn-primary" : b.danger ? "btn-text-danger" : "btn-secondary"} btn-compact btn-card w-full`}
            style={{ height: large ? 42 : 34, padding: "0 6px", fontSize: large ? 14 : 12.5, lineHeight: "14px", whiteSpace: "nowrap", ...(b.danger && { border: "1px solid color-mix(in srgb, var(--danger) 45%, transparent)" }) }}
          >
            {b.label}
          </button>
          {!b.enabled && b.reason && (
            <span data-testid={`${b.testid}-reason`} className="text-center" style={{ overflowWrap: "anywhere", fontSize: large ? 12 : 10.5, lineHeight: "13px", color: "var(--ink-4)" }}>
              {b.reason}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
